<template>
  <div class="functionDialog">
    <el-dialog
        :before-close="handleClose"
        :show-close="showClose"
        :visible.sync="visible"
        :width="width"
        :close-on-click-modal="closeClick"
        center>
      <div slot="title">
        <dialog-header :title="dialogTitle"></dialog-header>
      </div>
      <slot name="content"></slot>
      <slot name="footer"></slot>
    </el-dialog>
  </div>
</template>

<script>
import DialogHeader from "@/components/device_details/comp/DialogHeader";

export default {
  name: "FunctionDialogComponent",
  components: {DialogHeader},
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: '40vw',
    },
    dialogTitle: {
      type: String,
      default: '',
    },
    showClose: {
      type: Boolean,
      default: true,
    },
    closeClick: {
      type: Boolean,
      default: true,
    },
    widthList: {
      type: Array,
      default: () => [],
    }
  },
  watch: {
    dialogVisible: {
      handler(val) {
        this.visible = val
      }
    },
  },
  data() {
    return {
      visible: false,
    }
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        if (this.widthList.length > 0) {
          this.widthList.forEach(item => {
            if (window.innerWidth < item.innerWidth) {
              this.width = item.width
            }
          })
        }
      })();
    };
  },
  methods: {
    handleClose() {
      this.visible = false
      this.$emit('dialogClose', this.visible)
    }
  },
  destroyed() {
    window.onresize = null
  }
}
</script>

<style>
@media (max-width: 767px) {
  .functionDialog .el-dialog {
    width: 80% !important;
    max-width: 1200px;
    /*height: 100%;*/
  }
}

/*.functionDialog .el-dialog {*/
/*  margin-top: 20vh !important;*/
/*}*/

</style>
